// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__rr","cls2":"AuthorHeader-cls2_Zdk AuthorHeader-cls1__rr","variant-dense":"AuthorHeader-variant-dense__M0"};